import React, {useEffect, useMemo} from 'react';
import {useNoticesUIContext} from "../NoticesUIContext";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as actions from '../../../_redux/notices/NoticesActions';
import {Modal} from "react-bootstrap";
import {ModalProgressBar} from "../../../../../../_metronic/_partials/controls";

export function NoticeDeleteDialog({id, show, onHide}) {
    const noticesUIContext = useNoticesUIContext();
    const noticesUIProps = useMemo(() => {
        return {
            setIds: noticesUIContext.setIds,
            queryParams: noticesUIContext.queryParams
        }
    }, [noticesUIContext]);
    
    
    const dispatch = useDispatch();
    const {isLoading} = useSelector(
        (state) => ({isLoading: state.notices.actionsLoading}),
        shallowEqual
    );
    
    useEffect(() => {
        if (!id)
            onHide();
    }, [id]);
    
    useEffect(() => {}, [isLoading, dispatch]);
    
    const deleteNotice = () => {
        dispatch(actions.deleteNotice(id)).then(() => {
            dispatch(actions.fetchNotices(noticesUIProps.queryParams));
            
            noticesUIProps.setIds([]);
            
            onHide();
        })
    }
    
    
    return(
        <Modal
            show={show}
            onHide={onHide}
        >
            {isLoading && <ModalProgressBar variant={"query"}/> }
            
            <Modal.Header closeButton>
                <Modal.Title>
                    حذف اطلاعیه
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!isLoading && (
                    <span>آیا از حذف اطلاعیه انتخاب شده مطمئن هستید؟</span>
                )}
                {isLoading && <span>در حال حذف اطلاعیه...</span>}
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <button
                        type="button"
                        onClick={onHide}
                        className="btn btn-light btn-elevate"
                    >
                        لغو
                    </button>
                    <> </>
                    <button
                        type="button"
                        onClick={deleteNotice}
                        className="btn btn-delete btn-elevate"
                    >
                        تایید
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}